var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsTimeOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB536A;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E0301E;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2_10_",
    d: "M52,13.5c-19.9,0-36,16.1-36,36s16.1,36,36,36c19.9,0,36-16.1,36-36S71.9,13.5,52,13.5z M52,81 c-17.4,0-31.5-14.1-31.5-31.5S34.6,18,52,18s31.5,14.1,31.5,31.5S69.4,81,52,81z M54.3,47.3V27.2h-4.5v24.6h24.6v-4.5H54.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsTimeOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Time_Outline_Black_RGB.773b78c33fe16816672999d155a7160c.svg";
export { ForwardRef as ReactComponent };